var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1889 3.25198L7.15895 6.54706C1.08895 8.77673 1.08895 12.4123 7.15895 14.631L9.83895 15.6085L10.7289 18.5521C12.7489 25.2192 16.0689 25.2192 18.0889 18.5521L21.0989 8.64493C22.4389 4.19657 20.2389 1.76919 16.1889 3.25198ZM16.5089 9.16116L12.7089 13.3569C12.5589 13.5217 12.3689 13.5985 12.1789 13.5985C11.9889 13.5985 11.7989 13.5217 11.6489 13.3569C11.3589 13.0384 11.3589 12.5112 11.6489 12.1926L15.4489 7.9969C15.7389 7.67837 16.2189 7.67837 16.5089 7.9969C16.7989 8.31542 16.7989 8.84264 16.5089 9.16116Z",
    fill: "#576EDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/Send_message.b1d6419cfb65c76769d2834b03befd8c.svg";
export { ForwardRef as ReactComponent };